import { defineStore } from 'pinia';
import { useStorage } from 'vue3-storage';
import { eventEmitter } from '@/services/event-emitter.service';
const localStorage = useStorage({ namespace: '', storage: 'local' });

export const useMediaStore = defineStore('media', {
  state() {
    return {
      // if there's any error in device selection, AVDeviceSelectionReInitRequestedAt will be set to the time of the error
      // we'll add a watch on this property to reinitialize the device selection
      AVDeviceSelectionReInitRequestedAt: null,
      isCameraPermissionGranted: true,
      readinessSessionInitialized: false,
      devices: [],
      userDevices: {},
      audioSource: false,
      audioOutputSource: false,
      videoSource: false,
      videoSourceActive: false,
      videoKind: false,
      audioOn: true,
      audioOutputOn: true,
      videoOn: true,
      stopScreenSharingRequestTs: 0,
      inprogressMuteRequests: [],
    };
  },
  getters: {
    screenSharing: (s) => s.videoKind === 'screen',
    cameraSharing: (s) => s.videoKind === 'camera',
    isMuteOrUnmuteInProgress: (s) => (actionType) => s.inprogressMuteRequests.some((inprogressRequests) => inprogressRequests.type === actionType),
  },
  actions: {
    initMeeting(data) {
      this.setPresentationSources({ phase: data.state.current_phase });
    },
    initReadinessCheckSession(v) {
      this.readinessSessionInitialized = v;
    },
    setPresentationSources({ phase }) {
      this.videoKind = phase.source || false;
      this.videoSourceActive = phase.isSourceActive || false;
    },
    sourceSwitched({ isSourceActive, source }) {
      this.videoKind = source;
      this.videoSourceActive = isSourceActive;
      eventEmitter.emit('bus:videoSourceChanged', source);
    },
    updateDevices(v) {
      this.devices = [...v];
    },
    updateDevicesByDeviceKind({ deviceKind, devices }) {
      const otherDevices = [...this.devices].filter((device) => device.kind !== deviceKind);
      this.devices = [...otherDevices, ...devices];
    },
    updateUserDevices(v) {
      Object.entries(v).forEach(([key, value]) => {
        if (!value) {
          return;
        }
        this.userDevices = { ...this.userDevices, ...{ [key]: value } };
      });
    },
    setAudioSource(v) {
      this.audioSource = v;
    },
    setAudioOutputSource(v) {
      this.audioOutputSource = v;
    },
    setVideoSource(v) {
      this.videoSource = v;
    },
    setAudioOn(v) {
      localStorage.setStorageSync('user:audioOn', v);
      this.audioOn = v;
    },
    setAudioOutputOn(v) {
      localStorage.setStorageSync('user:audioOutputOn', v);
      this.audioOutputOn = v;
    },
    setVideoOn(v) {
      localStorage.setStorageSync('user:videoOn', v);
      this.videoOn = v;
    },
    markAsCameraPermissionNotGranted() {
      this.isCameraPermissionGranted = false;
    },
    setStopScreenSharingTimestamp(v) {
      this.stopScreenSharingRequestTs = v;
    },
    updateInProgressMuteRequests({ type, isInProgress }) {
      if (isInProgress) {
        this.inprogressMuteRequests = [...this.inprogressMuteRequests, { type }];
      } else {
        this.inprogressMuteRequests = this.inprogressMuteRequests.filter((r) => r.type !== type);
      }
    },
    requestReInitDeviceSelection() {
      this.AVDeviceSelectionReInitRequestedAt = Date.now();
    },
  },
});
